import If from 'global/ErrorHandlers/If';
import { ContainerImage, ImageSingle } from './styled';
import { IImageData } from './types';
import { getFileExtension } from './utils';

interface SingleImageProps {
  image: IImageData;
  onClick: () => void;
  isLoggedIn?: boolean;
  mode: 'post' | 'comment';
}

export default function SingleImage({
  image,
  onClick,
  isLoggedIn,
  mode,
}: SingleImageProps) {
  const extension = getFileExtension(image.image);
  const isGifExt = extension.toLowerCase().includes('gif');
  return (
    <ContainerImage isGif={isGifExt} onClick={onClick}>
      <If condition={isLoggedIn}>
        <ImageSingle
          src={image.image}
          imageFrameType={image.frame_type || 'FRAME_TYPE_UNSPECIFIED'}
          isGif={isGifExt}
          onClick={onClick}
          mode={mode}
        />
      </If>
      <If condition={!isLoggedIn}>
        <ImageSingle
          src={image.image}
          imageFrameType="FRAME_TYPE_UNSPECIFIED"
          isGif={isGifExt}
          onClick={onClick}
          mode="post"
        />
      </If>
    </ContainerImage>
  );
}
